"use client";

import { ListingsSearch } from "@/components";
import React from "react";

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  return (
    <div className="w-full max-w-2xl">
      <ListingsSearch
        onChange={onSearch}
        placeholder="Search for bags, brands, or keywords..."
      />
    </div>
  );
};

export default SearchBar;
